import React from "react";

export const Experiences = React.lazy(() => import("../components/Experiences/Experiences"))
export const Projects = React.lazy(() => import("../components/Projects/Projects"))
export const Skills = React.lazy(() => import("../components/Skills/Skills"))
export const Services = React.lazy(() => import("../components/Services/Services"))
export const OneProjectDetailed = React.lazy(() => import("../components/Projects/OneProject/OneProjectDetailed"))
